var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEmbeds = void 0;

var react_1 = require("react");

var admin_core_1 = require("@wheelroom/admin-core");

exports.useEmbeds = function (gatsbyProps) {
  var _react_1$useContext = react_1.useContext(admin_core_1.AdminCoreContext),
      adminCoreState = _react_1$useContext.adminCoreState;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      embedsDone = _react_1$useState2[0],
      setEmbedsDone = _react_1$useState2[1];

  var globals = gatsbyProps.data.globals;

  if (!embedsDone && globals.siteEmbeds && Array.isArray(globals.siteEmbeds)) {
    var isAppInit = adminCoreState.lastModuleId === '*';
    globals.siteEmbeds.forEach(function (embed) {
      if (embed.code && embed.type === 'js-page') {
        Function('props', embed.code.code)(gatsbyProps);
      }

      if (isAppInit && embed.code && embed.type === 'js-app') {
        Function('props', embed.code.code)(gatsbyProps);
      }
    });
    setEmbedsDone(true);
  }
};